interface analysisReport {
  totalAssets: number;
  totalExpenses: number;
  totalLiabilities: number;
  totalRevenue: number;
}

export interface FundsOpenSearch {
  fund?: Fund;
  sortIndex?: number[];
  score: string;
}

export interface Fund {
  status?: number;
  enStatus?: number;
  about?: string;
  en_about?: string;
  brief?: string;
  en_brief?: string;
  cat_ids?: [];
  fb_id?: string;
  fund_name?: string;
  en_fund_name?: string;
  logo?: string;
  organizationId?: number;
  fund_type?: number;
  updatedAt?: Date;
  updated_at?: Date;
  created_at?: Date;
  addressOne?: string;
  addressTwo?: string;
  geo_address_he?: string;
  geo_address_en?: string;
  url?: string;
  emailOne?: string;
  emailTwo?: string;
  country?: string;
  phoneOne?: string;
  phoneTwo?: string;
  fax?: string;
  facebook?: string;
  youtube?: string;
  instagram?: string;
  linkedin?: string;
  amountFunded?: string;
  totalGiving?: string;
  limitations?: string;
  en_limitations?: string;
  monthsToApply?: string;
  howToApply?: string;
  more_details?: string;
  en_more_details?: string;
  supported_organizations?: string;
  en_supported_organizations?: string;
  delegations_he?: Delegations[];
  delegations_en?: Delegations[];
  last_submission_date?: Date;
  dgeshim?: string;
  en_dgeshim?: string;
  submitMethod?: string;
  en_submitMethod?: string;
  areaOfInterestsList?: any;
  en_areaOfInterestsList?: any;
  readAt?: Date;
  availableLanguages: ('he' | 'en')[];
}

export interface NewestFund {
  fb_id: string;
  fund_name?: string;
  about?: string;
  brief?: string;
  logo?: string;
  fund_type: number;
  created_at?: Date;
  updated_at?: Date;
  is_new?: boolean;
}

export interface Delegations {
  country: string;
  text: string;
}

export interface FundsCount {
  foundationCount: number;
  businessCount: number;
  publicAppealCount: number;
}

export interface FundDetails {
  about: Fund;
  amountByCategories: [];
  financialReport: FinancialReport[];
  geographic: Geographic[];
  grants: [];
  interests: { id: number }[];
  people: People[];
  allPeople: People[];
  gsData: FundGsData[];
  changeDescription?: string;
}

export interface FinancialReport {
  fileUrl: string;
  year: number;
  analysis: analysisReport;
}

export interface Geographic {
  text_en?: string;
  text_he?: string;
  viewport: { southwest: { lat: number; lng: number }; northeast: { lat: number; lng: number } };
  location: { lat: number; lng: number };
}

export interface SupportedOrgs {
  name: string;
  address: string;
  amount: number;
}

export interface People {
  fullName: string;
  fullNameCache: string;
  descriptionCache: string;
  positionCache: string;
  position: string;
  language: string;
  phone: string;
  url: string;
  email: string;
  address: string;
  description: string;
}

export interface FundAmountByCategory {
  catId: number;
  amount: number;
}

export interface FundAmountByGrant {
  key: string;
  amount: number;
}

export interface FundGsData {
  key: string;
  data: FundGsDataArea[] | FundGsDataCategory[];
}

export interface FundGsDataArea {
  key?: string;
  value?: number;
  area?: string;
}

export interface FundGsDataCategory {
  key?: string;
  value?: number;
  text?: string;
}

// helpers
export enum FundTypeEnum {
  foundation = 1,
  corporation = 2,
  goverment = 3,
  endowment = 4,
}

export function fundTypeToBackgroundColor(fundType?: FundTypeEnum) {
  const styles = getComputedStyle(document.documentElement);
  switch (fundType) {
    case FundTypeEnum.foundation:
      return styles.getPropertyValue('--color-foundation').trim();
    case FundTypeEnum.corporation:
      return styles.getPropertyValue('--color-business').trim();
    case FundTypeEnum.goverment:
      return styles.getPropertyValue('--color-rfp').trim();
    case FundTypeEnum.endowment:
      return styles.getPropertyValue('--color-endowment').trim();
    default:
      return '#BCBCBC'; // default color
  }
}

export function fundTypeToTextColor(fundType?: FundTypeEnum) {
  switch (fundType) {
    case FundTypeEnum.foundation:
      return '#FFF';
    case FundTypeEnum.corporation:
      return '#FFF';
    case FundTypeEnum.goverment:
      return '#FFF';
    case FundTypeEnum.endowment:
      return '#FFF';
    default:
      return '#FFF';
  }
}

export function fundTypeToText(fundType?: FundTypeEnum) {
  switch (fundType) {
    case FundTypeEnum.foundation:
      return 'Foundation';
    case FundTypeEnum.corporation:
      return 'Corporation';
    case FundTypeEnum.goverment:
      return 'Goverment';
    case FundTypeEnum.endowment:
      return 'Endowment';
    default:
      return 'Unknown';
  }
}
